var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.users),function(user){return _c('li',[_vm._v(_vm._s(user.name)+" "+_vm._s(user.lastname))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }